export const APP_UTM_SOURCE = 'app';
export const APP_UTM_MEDIUM = 'app_shopping';
